import { render, staticRenderFns } from "./VToolbar.vue?vue&type=template&id=55a3434a"
import script from "./VToolbar.vue?vue&type=script&lang=js"
export * from "./VToolbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports